export default __webpack_public_path__ + "static/media/logo-black.7f170cff.png";